import React, {useState, useEffect, useContext} from 'react';
import axios from "@common/axios";
import ListItem from "@common/ListItem";
import {UserContext} from "@context/UserContext";

const ActForUser = props => {
    const {shortcut} = props;
    const {user, setUser} = useContext(UserContext);

    return (
        <ListItem isDisclosureItem={true} onClick={clearActForUser}>
            Clear acting for {user.username}
        </ListItem>
    )
}

export default ActForUser;